import type { HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Status labels always come as a pair: tone text + its `-bg`
// (/design-system/GUIDE.md rule 7). Warning is orange, never yellow.
const badgeVariants = cva(
	"inline-flex items-center gap-1 whitespace-nowrap rounded-lg px-2 py-0.5 text-2xs font-semibold",
	{
		variants: {
			tone: {
				neutral: "bg-bg-sunken text-text-secondary",
				brand: "bg-brand-100 text-brand-900",
				success: "bg-success-bg text-success",
				warning: "bg-warning-bg text-warning",
				danger: "bg-danger-bg text-danger",
				info: "bg-info-bg text-info",
				ai: "bg-ai-bg text-ai",
			},
		},
		defaultVariants: {
			tone: "neutral",
		},
	},
);

interface BadgeProps
	extends HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, tone, ...props }: BadgeProps) {
	return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}

export { Badge, badgeVariants, type BadgeProps };
